import React, { useState, useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
// import classes from "../assets/styles/DashboardLayout.module.css";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { loggedInUser, mobileViewCheck } from "../utils/store";
import chroma from "chroma-js";
import { get, post } from "../server";
import { THEME_GET, CREATE_CHAT_SESSION, SEND_CHAT_MESSAGE, GET_CHAT_SESSION, GET_CHAT_HISTORY } from "../utils/constants/apiUrl";
// import FeedbackModal from "../components/Modals/FeedbackModal";
import Cookies from "js-cookie";
import { FaHeadset, FaTimes, FaArrowUp } from "react-icons/fa";
import aiLogo from "../assets/images/ai-logo.png";
import Offcanvas from "react-bootstrap/Offcanvas";

const renderFormattedText = (text) => {
  if (!text || typeof text !== "string") return text;

  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
};

const DashboardLayout = () => {
  const [showChat, setShowChat] = useState(false);
  const [sessionUuid, setSessionUuid] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [isSending, setIsSending] = useState(false);
  const chatBodyRef = useRef(null);

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showBackDrop, setShowBackDrop] = useState(false);
  const [mobileView, setMobileView] = useAtom(mobileViewCheck);
  const location = useLocation();
  const isNavigatingRef = useRef(false);
  const prevLocation = useRef(location);
  const [feedbackModal, setFeedbackModal] = useState(false);

  const handleCloseFeedbackModal = () => {
    setFeedbackModal(false);
    Cookies.set("showFeedbackModal", 0, {
      secure: true,
      expires: 7, // corrected from 'expire'
      sameSite: "Strict",
    });
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 900) {
      setMobileView(false);
    } else {
      setMobileView(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", resizeFunction);

    if (window.innerWidth >= 960) {
      setMobileView(false);
    } else {
      setMobileView(true);
    }

    return function cleanup() {
      window.removeEventListener("resize", resizeFunction);
    };
  }, []);

  const navigate = useNavigate();
  // if (Object.keys(loggedUser).length > 0) {
  //   navigate("/");
  // }

  const handleShowSidebar = () => {
    if (isSidebarCollapsed) {
      let collapsdSideMenu = document.querySelector(".collapsedSidebar");
      collapsdSideMenu.classList.add("show");
      setShowBackDrop(true);
      // setShowBackDrop((preValue) => !preValue);
    } else {
      let sideMenu = document.querySelector(".sidebar");
      sideMenu.classList.add("show");
      setShowBackDrop(true);
      // setShowBackDrop((preValue) => !preValue);
    }
  };

  const handleHideSidebar = () => {
    if (isSidebarCollapsed) {
      let collapsdSideMenu = document.querySelector(".collapsedSidebar");
      collapsdSideMenu.classList.remove("show");
      setShowBackDrop(false);
      // setShowBackDrop((preValue) => !preValue);
    } else {
      let sideMenu = document.querySelector(".sidebar");
      sideMenu.classList.remove("show");
      setShowBackDrop(false);

      // setShowBackDrop((preValue) => !preValue);
    }
  };

  // ✅ Detect route changes and show feedback modal
  useEffect(() => {
    if (
      loggedUser?.is_feedback_form === 1 &&
      location.pathname !== prevLocation.current.pathname &&
      !loggedUser?.role?.includes("super_admin")
      // && Cookies.get("showFeedbackModal") !== 0
    ) {
      setFeedbackModal(true);
    }

    prevLocation.current = location;
  }, [location.pathname, loggedUser?.is_feedback_form]);

  // // ✅ Detect browser close and mark to show feedback next load
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (
        loggedUser?.is_feedback_form === 1 &&
        !loggedUser?.role?.includes("super_admin")
        // && Cookies.get("showFeedbackModal") !== 0
      ) {
        localStorage.setItem("showFeedbackModal", 1);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [loggedUser?.is_feedback_form]);

  // ✅ Show modal if it was triggered on browser close
  useEffect(() => {
    if (
      localStorage.getItem("showFeedbackModal") === 1 &&
      !loggedUser?.role?.includes("super_admin") &&
      Cookies.get("showFeedbackModal") !== 0
    ) {
      setFeedbackModal(true);
      // localStorage.removeItem("showFeedbackModal");
    }
  }, []);

  // --- CHATBOT LOGIC ---

  // Try to load and validate existing session from local storage on mount
  const loadExistingSession = async (uuid) => {
    try {
      // console.log(`[API CALL] GET_CHAT_SESSION for UUID: ${uuid}`);
      // Validate session with backend
      const res = await get(`${GET_CHAT_SESSION}${uuid}`, loggedUser?.token || null);
      // console.log("[API RESPONSE] GET_CHAT_SESSION result:", res);

      if (res && res.data) {
        // If data is returned, session is valid. Fetch history.
        setSessionUuid(uuid);
        fetchChatHistory(uuid);
      } else {
        // Invalid or expired session
        localStorage.removeItem("chat_session_uuid");
        setSessionUuid(null);
      }
    } catch (e) {
      // API Failed or 404
      // console.error("[API ERROR] GET_CHAT_SESSION failed:", e);
      localStorage.removeItem("chat_session_uuid");
      setSessionUuid(null);
    }
  };

  useEffect(() => {
    const savedSession = localStorage.getItem("chat_session_uuid");
    if (savedSession && loggedUser?.token) {
      loadExistingSession(savedSession);
    }
  }, [loggedUser?.token]);

  // Init chat session when opening chat if not initialized
  useEffect(() => {
    if (showChat && !sessionUuid && loggedUser?.token) {
      initChatSession();
    }
  }, [showChat, sessionUuid, loggedUser?.token]);

  // Scroll to bottom when messages update
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [chatMessages]);

  const initChatSession = async () => {
    try {
      // API expects session_id: null for new session
      // console.log(`[API CALL] CREATE_CHAT_SESSION`);
      const res = await post(CREATE_CHAT_SESSION, { session_id: null }, loggedUser?.token || null);
      // console.log("[API RESPONSE] CREATE_CHAT_SESSION result:", res);

      if (res && res.data) {
        const sid = res.data.session_uuid || res.data.session_id;
        if (sid) {
          setSessionUuid(sid);
          localStorage.setItem("chat_session_uuid", sid);
        }

        // Use the greeting_message from API if provided
        const greeting = res.data.greeting_message || "Hi! I'm Contact Co. Support. I'm here to help with questions about ContactCo.com products, the app, and support. What can I help you with today?\n\nBest regards -\nContact Co. Support";

        setChatMessages([
          { role: "agent", text: greeting, time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
        ]);
      } else {
        // Fallback greeting if API fails or parsing fails
        setChatMessages([
          { role: "agent", text: "Hi! I'm Contact Co. Support. I'm here to help with questions about ContactCo.com products, the app, and support. What can I help you with today?\n\nBest regards -\nContact Co. Support", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
        ]);
      }
    } catch (e) { console.error("Error creating chat session", e); }
  };

  const fetchChatHistory = async (uuid) => {
    try {
      // console.log(`[API CALL] GET_CHAT_HISTORY for UUID: ${uuid}`);
      const res = await get(`${GET_CHAT_HISTORY}${uuid}`, loggedUser?.token || null);
      // console.log("[API RESPONSE] GET_CHAT_HISTORY result:", res);

      let historyArray = [];
      if (res && res.data) {
        if (Array.isArray(res.data)) {
          historyArray = res.data;
        } else if (res.data.messages && Array.isArray(res.data.messages)) {
          historyArray = res.data.messages;
        } else if (res.data.history && Array.isArray(res.data.history)) {
          historyArray = res.data.history;
        } else if (res.data.data && Array.isArray(res.data.data)) {
          historyArray = res.data.data;
        }
      }

      if (historyArray.length > 0) {
        const formatted = historyArray.map(m => ({
          role: m.sender || m.role || (m.is_user ? 'user' : 'agent'),
          text: m.message || m.text || m.content,
          time: m.created_at ? new Date(m.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''
        }));
        setChatMessages(formatted);
      } else {

        // fallback to initializing a new chat if history couldn't properly fetch
        initChatSession();
      }
    } catch (e) { console.error("Error fetching chat history", e); }
  };

  const handleSendMessage = async (e) => {
    if (e) e.preventDefault();
    if (!messageInput.trim() || isSending) return;

    let currentUuid = sessionUuid;
    if (!currentUuid) {
      try {
        const sessionRes = await post(CREATE_CHAT_SESSION, { session_id: null }, loggedUser?.token || null);
        if (sessionRes && sessionRes.data) {
          currentUuid = sessionRes.data.session_uuid || sessionRes.data.session_id;
          if (currentUuid) {
            setSessionUuid(currentUuid);
            localStorage.setItem("chat_session_uuid", currentUuid);
          }
        }
      } catch (e) { }
    }

    const userMsg = messageInput;
    setMessageInput("");
    setIsSending(true);

    const timeNow = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    setChatMessages(prev => [...prev, { role: "user", text: userMsg, time: timeNow }]);

    try {
      const payload = { session_id: currentUuid, message: userMsg };
      const res = await post(SEND_CHAT_MESSAGE, payload, loggedUser?.token || null);
      if (res && res.data) {
        const agentText = res.data.message || res.data.response || res.data.text || res.data || "I received your message.";
        setChatMessages(prev => [...prev, { role: "agent", text: agentText, time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
      } else if (res && res.message) {
        // sometimes the message is straight on the top level
        setChatMessages(prev => [...prev, { role: "agent", text: res.message, time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
      } else {
        setChatMessages(prev => [...prev, { role: "agent", text: "Sorry, an error occurred.", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
      }
    } catch (err) {
      setChatMessages(prev => [...prev, { role: "agent", text: "Sorry, network error.", time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }]);
    }
    setIsSending(false);
  };

  return (
    <>
      <style>{`
        .typing-indicator {
          display: flex;
          align-items: center;
          gap: 4px;
          height: 24px;
        }
        .typing-indicator span {
          display: block;
          width: 5px;
          height: 5px;
          background-color: #6ab28c;
          border-radius: 50%;
          animation: typing 1.4s infinite ease-in-out both;
        }
        .typing-indicator span:nth-child(1) {
          animation-delay: -0.32s;
        }
        .typing-indicator span:nth-child(2) {
          animation-delay: -0.16s;
        }
        @keyframes typing {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
      `}</style>
      <div className="d-flex position-relative">
        <Sidebar
          isSidebarCollapsed={isSidebarCollapsed}
          setIsSidebarCollapsed={setIsSidebarCollapsed}
          handleHideSidebar={handleHideSidebar}
        />
        <div className={isSidebarCollapsed ? "collapsedMain" : "main"}>
          <Navbar
            isSidebarCollapsed={isSidebarCollapsed}
            setShowBackDrop={setShowBackDrop}
            handleShowSidebar={handleShowSidebar}
          />
          <div
            className={showBackDrop ? "backdrop open" : "backdrop"}
            onClick={handleHideSidebar}
          ></div>
          <div
            className="container-fluid py-2 px-4"
            style={{ minHeight: "calc(100vh - 60px)" }}
          >
            <Outlet />
          </div>

          <button
            className="chatbot-toggle-btn position-fixed"
            onClick={() => setShowChat(true)}
          >
            <FaHeadset />
          </button>
        </div>
      </div>

      {/* Chat Offcanvas Drawer */}
      <Offcanvas
        show={showChat}
        onHide={() => setShowChat(false)}
        placement="end"
        className="custom-chat-offcanvas"
        style={{ width: mobileView ? '100%' : '500px', zIndex: 1060 }}
      >
        <button
          onClick={() => setShowChat(false)}
          className="chat-close-btn shadow"
        >
          <FaTimes />
        </button>

        <Offcanvas.Body className="d-flex flex-column p-0">
          <div className="flex-grow-1 overflow-auto p-3" style={{ gap: '10px' }} ref={chatBodyRef}>

            <div className="chat-header-custom mb-4 mt-2">
              <img src={aiLogo} alt="AI Avatar" className="bot-avatar" />
              <h4>Hi 👋, I am Link</h4>
              <p className="text-muted small mb-0">Ask me anything</p>
            </div>

            {chatMessages.map((msg, idx) => (
              <div key={idx} className={msg.role === 'user' ? "message-user mt-4" : "message-agent mt-4"}>
                {msg.role !== 'user' ? (
                  <>
                    <div className="meta">
                      <img src={aiLogo} alt="AI" style={{ width: '25px', height: '25px', borderRadius: '50%', backgroundColor: '#EBF1F5', padding: '2px', border: '1px solid #83c5a2' }} />
                      <span>Assistant {msg.time}</span>
                    </div>
                    <div className="bubble" style={{ whiteSpace: "pre-wrap" }}>
                      {renderFormattedText(msg.text)}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="meta">{msg.time}</div>
                    <div className="bubble" style={{ whiteSpace: "pre-wrap" }}>
                      {renderFormattedText(msg.text)}
                    </div>
                  </>
                )}
              </div>
            ))}

            {isSending && (
              <div className="message-agent mt-4">
                <div className="meta">
                  <img src={aiLogo} alt="AI" style={{ width: '25px', height: '25px', borderRadius: '50%' }} />
                  <span>Assistant typing...</span>
                </div>
                <div className="bubble text-muted" style={{ padding: '8px 16px', display: 'inline-block' }}>
                  <div className="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}

          </div>

          <div className="chat-footer-custom mt-auto">
            <form onSubmit={handleSendMessage} className="d-flex bg-white pe-2 align-items-center" style={{ borderRadius: '10px' }}>
              <input
                type="text"
                className="form-control border-0 shadow-none"
                placeholder="Type your message..."
                style={{ borderRadius: '10px', padding: '15px' }}
                value={messageInput}
                onChange={(e) => setMessageInput(e.target.value)}
                disabled={isSending}
              />
              <button type="submit" className="chat-send-btn" disabled={!messageInput.trim() || isSending}>
                <FaArrowUp />
              </button>
            </form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* <FeedbackModal
        show={feedbackModal}
        handleClose={handleCloseFeedbackModal}
      /> */}
      {/* <Footer /> */}
    </>
  );
};

export default DashboardLayout;
